<template>
    <div ref="os-input">
        <label v-if="label" class="block text-sm font-medium text-gray-700 text-left" :class="{'text-red-500': error, 'dark:text-white': !ignoreDarkMode }" v-text="label" />
        <div class="mt-2 relative rounded-md shadow-sm">
            <component :is="multiline ? 'textarea' : 'input'" :type="localType" class="block w-full pr-10 focus:outline-none sm:text-sm rounded-md disabled:bg-gray-100" :name="name" :class="[
                       {'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500': error},
                       {'border-gray-300 text-gray-900 placeholder-gray-300 focus:ring-gray-500 focus:border-gray-500': !error}
                   ]" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" :placeholder="placeholder" :disabled="disabled" :readonly="readonly" />
            <div v-if="type === 'password' && !error">
                <div v-if="localType === 'password'" class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer">
                    <EyeOffIcon @click="localType = 'text'" class="h-5 w-5 text-gray-700" aria-hidden="true" />
                </div>
                <div v-else class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer">
                    <EyeIcon @click="localType = 'password'" class="h-5 w-5 text-gray-700" aria-hidden="true" />
                </div>
            </div>
            <div v-if="error" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
            </div>
        </div>
        <p v-if="error" class="mt-1 text-sm text-red-600 text-left" v-text="error" />
        <p v-else-if="persistentHint || (modelValue && hint)" class="mt-1 text-sm text-left" v-text="hint" />
    </div>
</template>
<script>
import { ExclamationCircleIcon, EyeOffIcon, EyeIcon } from '@heroicons/vue/solid'
import { getParentForm } from '../../_core/form-helpers'
import { computed } from "vue";

export default {
    props: {
        error: String,
        modelValue: {},
        label: String,
        errors: Object,
        placeholder: String,
        hint: String,
        multiline: Boolean,
        persistentHint: Boolean,
        readonly: Boolean,
        disabled: Boolean,
        name: String,
        type: {
            type: String,
            default: 'text'
        },
        ignoreDarkMode: Boolean,
    },
    components: {
        ExclamationCircleIcon,
        EyeOffIcon,
        EyeIcon
    },

    setup(props) {

        const form = getParentForm()

        const localType = props.type

        return {
            localType,
        }
    }
}

</script>
